'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var FormControl = require('../../../components/FormControl.js');
var TextInput = require('@narvar/nth-block-text-input');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthHookTheme = require('@narvar/nth-hook-theme');
var useFormState = require('../useFormState.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var TextInput__default = /*#__PURE__*/_interopDefaultLegacy(TextInput);

const EmailField = _ref => {
  let {
    error,
    value,
    onChange
  } = _ref;
  const {
    claimsOrderLookupEmailInputRequired,
    claimsOrderLookupEmailInputLabel
  } = nthHookTranslations.useTranslations();
  const {
    captiontextErrorNone
  } = nthHookTheme.useTheme();
  return /*#__PURE__*/React__default["default"].createElement(FormControl["default"], {
    error: error,
    helperText: error ? claimsOrderLookupEmailInputRequired : null
  }, /*#__PURE__*/React__default["default"].createElement(TextInput__default["default"], {
    id: useFormState.FieldName.email,
    type: TextInput.SupportedInputType.text,
    label: claimsOrderLookupEmailInputLabel || '',
    animateLabel: true,
    value: value,
    onChange: e => onChange(useFormState.FieldName.email, e.target.value)
    // Specifying "error" doesn't give us error styling on the input
    // because "inputtextinputsNoneError" does not appear to be defined
    ,
    error: error,
    containerOverridesStyle: {
      ...(error ? {
        borderColor: (captiontextErrorNone === null || captiontextErrorNone === void 0 ? void 0 : captiontextErrorNone.color) || '#E02020'
      } : undefined)
    }
  }));
};
var EmailField$1 = nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(EmailField, {
  themeTokens: ['captiontextErrorNone']
}), {
  translationKeys: ['claimsOrderLookupEmailInputRequired', 'claimsOrderLookupEmailInputLabel']
});

exports["default"] = EmailField$1;
